<template>
  <b-card>

    <b-form class="m-2">
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Número *" label-for="number">
            <b-form-input id="number" v-model="agencies.number" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Nombre *" label-for="name">
            <b-form-input id="name" v-model="agencies.name" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Teléfono" label-for="phone">
            <b-form-input id="phone" v-model="agencies.phone" trim></b-form-input>
            </b-form-group>
        </b-col>
         <b-col cols="12" md="3">
          <b-form-group label="Correo electrónico" label-for="email">
            <b-form-input id="email" v-model="agencies.email" trim></b-form-input>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Encargado" label-for="manager">
            <b-form-input id="manager" v-model="agencies.manager" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Meta de Instalación" label-for="goal">
            <b-form-input id="goal" v-model="agencies.goal" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Polígono" label-for="polygon">
            <b-form-input id="polygon" v-model="agencies.polygon" trim></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Acrónimo *" label-for="acronym">
            <b-form-input id="acronym" v-model="agencies.acronym" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Zona *" label-for="zona" >
            <v-select input-id="zona" :options="listZonas" :clearable="false" v-model="agencies.zoneUuid" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <div>
      <b-button type="submit" class="m-1" variant="primarySpore" @click="save()">Guardar</b-button>
      <b-button type="reset" class="m-1" variant="outline-danger" @click="cancel()">Cancelar</b-button>
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */

import {
  BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput
} from 'bootstrap-vue'

import request from '@/libs/request/index'
import { app } from '@/main'

export default {
  components: {
    BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput
  },
  data () {
    const divisionUuid = this.$store.state.session.AppActiveUser().division.uuid
    return {
      listZonas: [{ title: '', value: '', label: '' }],
      agencies: {
        number: '',
        name: '',
        phone: '',
        email: '',
        manager: '',
        goal: '',
        polygon: null,
        divisionUuid,
        zoneUuid: '',
        acronym: ''
      }
    }
  },
  methods: {
    cancel () {
      this.agencies.number = ''
      this.agencies.name = ''
      this.agencies.phone = ''
      this.agencies.email = ''
      this.agencies.manager = ''
      this.agencies.goal = ''
      this.agencies.zoneUuid = ''
      this.agencies.polygon = null
      this.agencies.acronym = ''
      app.$router.push('/agencies')
    },
    async getZonas () {
      const params = {
        url: '/zones',
        method: 'GET',
        params: { divisionUuid: this.$store.state.session.AppActiveUser().division.uuid }
      }
      await request(params).then(data => {
        if (data.status === 200) {
          for (const item of data.data) {
            this.listZonas.push({
              title: item.name,
              value: item.uuid,
              label: item.name
            })
          }
        }
      })
    },
    async save () {
      if (this.agencies.number === '' || this.agencies.name === '' || this.agencies.zoneUuid === '' || this.agencies.acronym === '') {
        this.$swal({
          title: 'Favor de ingresar los datos requeridos',
          text: '',
          timer: 5000,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-warning'
          },
          buttonsStyling: false
        })
      } else {
        const params = {
          url: '/agencies/',
          method: 'POST',
          params: this.agencies
        }
        await request(params).then(data => {
          app.$router.push('/agencies')
        })
      }
    }
  },
  created () {
    this.getZonas()
  }
}
</script>
